{
  "familyId": "SWW-VD-KOF",
  "questions": [
    {
      "id": "SWW-VD-KOF-001",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "De hond heeft hard ... (rennen).",
      "context": null,
      "options": ["gerend", "rent", "rende", "rennen"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": { "verb": "rennen", "stem": "ren", "lastLetter": "n", "useTE": false, "label": "Voltooid Deelwoord" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + d/t. De stam 'ren' eindigt op 'n' (niet in kofschip), dus: ge + ren + d = gerend.", "icon": "lightbulb" },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "past_participle_after_auxiliary",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: voltooid deelwoord met kofschip. Stap 1: Bepaal de stam: rennen − en = renn → ren. Stap 2: Kijk naar de laatste letter van de stam: 'n'. Stap 3: 'n' staat NIET in 't kofschip (T-K-O-F-S-CH-I-P), dus: ge + ren + d = gerend.",
        "distractorExplanations": {
          "0": "Correct! Kofschip-regel: 'n' niet in kofschip → ge + stam + d = gerend.",
          "1": "Veelgemaakte fout: tegenwoordige tijd gebruiken na een hulpwerkwoord. 'Rent' is de tegenwoordige tijd (hij rent). Na 'heeft' moet je het voltooid deelwoord gebruiken: heeft gerend. Misconceptie: de persoonsvorm verwarren met het voltooid deelwoord.",
          "2": "Veelgemaakte fout: verleden tijd gebruiken in plaats van voltooid deelwoord. 'Rende' is de verleden tijd. Na 'heeft' gebruik je het voltooid deelwoord met ge-: heeft gerend (niet heeft rende).",
          "3": "Veelgemaakte fout: het hele werkwoord gebruiken na een hulpwerkwoord. 'Rennen' is het hele werkwoord. Na 'heeft' gebruik je het voltooid deelwoord: heeft gerend (niet heeft rennen)."
        }
      }
    },
    {
      "id": "SWW-VD-KOF-002",
      "familyId": "SWW-VD-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_kofschip",
      "questionType": "multiple_choice",
      "question": "Ik heb de hele middag ... (fietsen).",
      "context": null,
      "options": ["gefietst", "gefietsd", "fietste", "fiets"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": { "verb": "fietsen", "stem": "fiets", "lastLetter": "s", "useTE": true, "label": "Voltooid Deelwoord" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": { "title": "Voltooid Deelwoord", "content": "Formule: ge + stam + t (bij kofschip). De stam 'fiets' eindigt op 's' (in kofschip), dus: ge + fiets + t = gefietst.", "icon": "lightbulb" },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "past_participle_kofschip",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Het voltooid deelwoord: ge + stam + t/d. De stam van 'fietsen' is 'fiets'. De laatste letter 's' zit WEL in 't kofschip, dus: ge + fiets + t = gefietst.",
        "distractorExplanations": {
          "0": "Correct! 'Gefietst' is het juiste voltooid deelwoord. De 's' zit in kofschip, dus +t.",
          "1": "'Gefietsd' is fout omdat je niet -d gebruikt bij een stam die op 's' eindigt. De 's' zit in kofschip, dus +t: gefietst.",
          "2": "'Fietste' is de verleden tijd. Na 'heb' gebruik je het voltooid deelwoord met ge-: gefietst.",
          "3": "'Fiets' is de stam. Na 'heb' gebruik je het voltooid deelwoord: ge + fiets + t = gefietst."
        }
      }
    }
  ]
}